// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'phone-merge';

export const Component = () => (
  <g
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='1.5'
  >
    <path d='m12.37 22.54.01.007a4.5 4.5 0 0 0 5.6-.615l.629-.629a1.5 1.5 0 0 0 0-2.122l-2.653-2.651a1.5 1.5 0 0 0-2.122 0h0a1.5 1.5 0 0 1-2.121 0l-4.242-4.243a1.5 1.5 0 0 1 0-2.121h0a1.5 1.5 0 0 0 0-2.122L4.819 5.393a1.5 1.5 0 0 0-2.121 0l-.63.629a4.5 4.5 0 0 0-.614 5.6l.006.01A40.606 40.606 0 0 0 12.37 22.54Zm4.88-9.79 3-3v-9m1.875 10.875 1.125 1.125' />
    <path d='m17.25 3.75 3-3 3 3' />
  </g>
);

export const viewBox = '0 0 24 24';
